module.exports = __webpack_public_path__ + "img/fig11.58c41968.jpg";